<template>
  <el-dialog
    title="供应商选择"
    v-model="visible"
    :close-on-click-modal="false"
    width="70%"
  >
    <el-form :model="searchData" :inline="true" ref="searchRef">
      <el-form-item label="供应商名称：" prop="name">
        <el-input v-model="searchData.name" placeholder="请输入供应商名称" />
      </el-form-item>
      <el-form-item label="供应商编号" prop="code">
        <el-input v-model="searchData.code" placeholder="请输入供应商编号" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="Search" @click="getList()"
          >查询</el-button
        >
        <el-button icon="Refresh" @click="handleReset()">重置</el-button>
        <el-button type="danger" icon="Delete" @click="handleClean()"
          >清空选中</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }"
      v-loading="loading"
      :data="tableData"
      ref="tableRef"
      :row-key="id"
      @row-click="handleRowClick"
    >
      <template v-for="item in columns" :key="item.prop">
        <el-table-column
          :label="item.label"
          :prop="item.prop"
          show-overflow-tooltip
          v-if="item.show ?? true"
        >
          <template #default="{ row }">
            <span>
              {{ row[item.prop] }}
            </span>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-pagination
      v-if="pages.total > 0"
      background
      style="margin-top: 10px"
      :current-page="pages.page"
      :page-size="pages.size"
      :page-sizes="[10, 20, 30, 50]"
      :total="pages.total"
      layout="->, total, prev, pager, next, sizes, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <template #footer> </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from "vue";
import { querySupplierList } from "@/api/supplier";
import { ElMessage } from "element-plus";

const emits = defineEmits(["selectDone"]);

// 弹窗控制
const visible = ref(false);

// 搜索表单ref
const searchRef = ref(null);

// 表格的ref
const tableRef = ref(null);

// 搜索条件
const searchData = reactive({
  name: null,
  code: null,
  warehouseId: null,
  gtZero: true,
});

// 表格列配置
const columns = ref([
  {
    label: "供应商编号",
    prop: "number",
  },
  {
    label: "供应商名称",
    prop: "name",
  },
  {
    label: "合作开始日期",
    prop: "startTime",
  },
  {
    label: "合作结束日期",
    prop: "endTime",
  },
  {
    label: "联系人",
    prop: "contact",
  },
  {
    label: "联系电话",
    prop: "mobile",
  },
]);

// 表格遮罩
const loading = ref(false);

// 表格数据
const tableData = ref([]);

// 分页数据
const pages = reactive({
  page: 1,
  size: 10,
  total: 0,
});
const handleSizeChange = (val) => {
  pages.size = val;
  pages.page = 1;
  getList();
};
const handleCurrentChange = (val) => {
  pages.page = val;
  getList();
};
// 清空所有选中
const handleClean = () => {
  tableRef.value?.clearSelection();
};

// 弹窗打开
const handleDialogOpen = () => {
  getList();
  visible.value = true;
};

// 获取数据
const getList = () => {
  loading.value = true;
  querySupplierList({
    ...searchData,
    page: pages.page,
    limit: pages.size,
    status: "1",
    needFilter: "1",
  })
    .then((res) => {
      tableData.value = res.data.records || [];
      pages.total = res.data.total;
    })
    .finally(() => {
      loading.value = false;
    });
};

// 列表选中
const handleRowClick = (row) => {
  console.log(row);
  emits("selectDone", row);
  visible.value = false;
};

// 重置
const handleReset = () => {
  searchRef.value?.resetFields();
  pages.page = 1;
  getList();
};

defineExpose({
  handleDialogOpen,
});
</script>

<style scoped></style>
